// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'rider',
  icon: [
    17,
    24,
    null,
    null,
    'M14.79 13.78h-1.247v-.914c.005-.352-.199-.537-.555-.533 0 0-.218-.005-.578 0V7.081c-.003-1.21-1.021-2.49-2.369-2.487H5.723L1.62.314C.718-.617-.602.73.305 1.654l5.237 5.45V22.85c.005 1.555 2.227 1.51 2.232 0v-9.07h.363v9.07c.005 1.511 2.245 1.555 2.244 0v-2.314h4.41V13.78zm-4.012-.914v.914h-.397V7.705h.397v5.16zM8.046 4.073c-1.073.002-1.945-.888-1.949-1.99C6.102.99 6.974.1 8.047.105 9.123.1 9.996.99 9.996 2.083c0 1.102-.873 1.993-1.95 1.99zm7.198 16.463V13.78h.85c.566.004.906.493.906.936v4.895c0 .441-.308.925-.906.925h-.85z',
  ],
})
